import { doc, getDoc, collection, getDocs, setDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Servicio para carga bajo demanda de tickets
 * Solo carga tickets cuando el usuario accede por primera vez
 */
export class OnDemandLoader {
  static async checkAndLoadTickets(raffleId) {
    try {
      // Verificar si ya se cargaron los tickets
      const metaRef = doc(db, 'raffles', raffleId, 'meta', 'loadStatus');
      const metaDoc = await getDoc(metaRef);
      
      if (metaDoc.exists() && metaDoc.data().ticketsLoaded) {
        console.log('Tickets already loaded for raffle:', raffleId);
        return false; // Ya fueron cargados
      }
      
      // Verificar si hay tickets en la colección
      const ticketsRef = collection(db, 'raffles', raffleId, 'tickets');
      const snapshot = await getDocs(ticketsRef);
      
      if (snapshot.size === 0) {
        // No hay tickets, solicitar carga desde la app
        console.log('No tickets found, requesting load from app...');
        await this.requestTicketLoad(raffleId);
        return true;
      }
      
      // Marcar como cargados
      await setDoc(metaRef, {
        ticketsLoaded: true,
        loadedAt: new Date(),
        ticketCount: snapshot.size
      });
      
      return false;
    } catch (error) {
      console.error('Error checking tickets:', error);
      return false;
    }
  }
  
  static async requestTicketLoad(raffleId) {
    try {
      // Crear una solicitud de carga en Firestore
      const requestRef = doc(db, 'raffles', raffleId, 'meta', 'loadRequest');
      await setDoc(requestRef, {
        requested: true,
        requestedAt: new Date(),
        status: 'pending'
      });
      
      console.log('Load request created for raffle:', raffleId);
      
      // La app Android escuchará este documento y cargará los tickets
      // cuando detecte la solicitud
    } catch (error) {
      console.error('Error requesting ticket load:', error);
    }
  }
}